import { Map, List } from 'immutable';

import createTypedReducer from '../createTypedReducer';
import * as facilityActions from './action';
import { CHANGE_CLIENT, CLEAR } from '../authentication/action';
import { IMPORT_DATA, IMPORT_DATA_SUCCESS, IMPORT_DATA_FAILED } from '../import/action';
import toast from 'src/utils/toast';
import { getTranslation } from 'src/i18n/translations';

export const initialState = Map({
  integrityChecks: Map(),
  guide: Map(),
  reportSchedules: Map()

});

function resetState (state) {
  return state.withMutations((nextState) =>
    nextState
      .set('integrityChecks', Map({
        data: Map()
      }))
      .set('guide', Map())
      .set('reportSchedules', Map())
      .set('metrics', Map())
  );
}

export const facilityReducer = createTypedReducer(initialState, {

  [facilityActions.SEND_REPORT_SUCCESS] (state) {
    toast.success(getTranslation('toast.reportSentSuccess'));
    return state.withMutations((nextState) =>
      nextState.set('guide', Map())
    );
  },

  [facilityActions.SEND_REPORT_FAILED] (state) {
    toast.error(getTranslation('toast.reportSentError'));
    return state;
  },


  [facilityActions.FETCH_REPORT_SCHEDULES] (state) {
    return state.withMutations((nextState) =>
      nextState.setIn(['reportSchedules', 'loading'], true)
    );
  },

  [facilityActions.FETCH_REPORT_SCHEDULES_SUCCESS] (state, action) {
    return state.withMutations((nextState) =>
      nextState.set('reportSchedules', Map({
        loading: false,
        data: action.reportSchedules
      }))
    );
  },

  [facilityActions.FETCH_REPORT_SCHEDULES_FAILED] (state) {
    return state.withMutations((nextState) =>
      nextState.setIn(['reportSchedules', 'loading'], false)
    );
  },


  [facilityActions.ADD_REPORT_SCHEDULE_SUCCESS] (state, action) {
    return state.withMutations((nextState) =>
      nextState.setIn(['reportSchedules', 'data'], nextState.getIn(['reportSchedules', 'data'], List()).push(action.reportSchedule))
    );
  },

  [facilityActions.UPDATE_REPORT_SCHEDULE_SUCCESS] (state, action) {
    return state.withMutations((nextState) => {
      const index = nextState.getIn(['reportSchedules', 'data'], List())
        .findIndex( (item) => item.get('id') === action.reportSchedule.get('id') );
      return (index !== -1) ? nextState.setIn(['reportSchedules', 'data', index], action.reportSchedule) : nextState;
    });
  },

  [facilityActions.DELETE_REPORT_SCHEDULE_SUCCESS] (state, action) {
    return state.withMutations((nextState) => {
      const index = nextState.getIn(['reportSchedules', 'data'], List())
        .findIndex( (item) => item.get('id') === action.reportScheduleId );
      return (index !== -1) ? nextState.deleteIn(['reportSchedules', 'data', index]) : nextState;
    });
  },

  [IMPORT_DATA] (state, action) {
    return state.withMutations((nextState) =>
      nextState.setIn(['guide', 'uploads', `${action.importFile.name}-${action.importFile.lastModified}`], {
        file: { name: action.importFile.name, lastModified: action.importFile.lastModified },
        fileObject: action.importFile,
        status: 'pending',
        importType: action.importType || 'otherData'
      })
    );
  },

  [IMPORT_DATA_SUCCESS] (state, action) {
    return state.withMutations((nextState) => {
      return nextState
        .setIn(['guide', 'uploads', `${action.importFile.name}-${action.importFile.lastModified}`, 'status'], 'success')
        .setIn(['guide', 'uploads', `${action.importFile.name}-${action.importFile.lastModified}`, 'importType'], action.importType)
        .setIn(['guide', 'uploads', `${action.importFile.name}-${action.importFile.lastModified}`, 'subType'], action.subType);
    });
  },

  [IMPORT_DATA_FAILED] (state, action) {
    return state.withMutations((nextState) =>
      nextState.setIn(['guide', 'uploads', `${action.importFile.name}-${action.importFile.lastModified}`, 'status'], action.status)
    );
  },
  [facilityActions.FETCH_METRICS] (state,) {
    return state.withMutations((nextState) =>
      nextState.setIn(['metrics', 'loading'], true)
    );
  },
  [facilityActions.FETCH_METRICS_SUCCESS] (state, action) {
    return state.withMutations((nextState) =>
      nextState.setIn(['metrics', 'data'], action.metrics)
        .setIn(['metrics', 'loading'], false)
    );
  },
  [facilityActions.FETCH_METRICS_FAILED] (state) {
    return state.withMutations((nextState) =>
      nextState.setIn(['metrics', 'loading'], false)
    );
  },

  [facilityActions.FETCH_INTEGRITY_CHECKS] (state) {
    return state.withMutations((nextState) =>
      nextState.setIn(['integrityChecks', 'loading'], true)
    );
  },
  [facilityActions.FETCH_INTEGRITY_CHECKS_SUCCESS] (state, action) {
    return state.withMutations((nextState) => {
      nextState.setIn(['integrityChecks', 'data'], action.integrityChecks);
      nextState.setIn(['integrityChecks', 'loading'], false);
    });
  },
  [facilityActions.FETCH_INTEGRITY_CHECKS_FAILED] (state) {
    return state.withMutations((nextState) =>
      nextState.setIn(['integrityChecks', 'loading'], false)
    );
  },

  [CLEAR] (state) {
    return resetState(state);
  },

  [CHANGE_CLIENT] (state) {
    return resetState(state);
  }
});

export default facilityReducer;
